import styled from "styled-components"

export const Container = styled.div`
  display: flex;
  box-sizing: border-box;

  & > :first-child {
    flex: 0 0 6rem;
    margin-right: 1rem;
  }
`
